import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {Container, LeftCol, List, RightCol} from '../components/Layout';
// import PoiMap from '../components/PoiMap';
import GeoPortailMap from '../components/GeoPortailMap';
import SwipeIndicator from '../components/SwipeIndicator';
import images from '../config/images';
import {
    SET_ACTIONBUTTON, SET_SELECTED_IMXATTRACTIONS,
    SET_SELECTED_Attractions,
    SET_SWIPEINDICATOR
} from '../redux/actions';


const PoiItem = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex: 0 0 auto;
    margin-bottom: 1px;
    cursor: pointer;
    user-select: none;
    background-repeat: no-repeat;
    background-position: ${props => props.theme.scale * 268}px ${props => props.theme.scale * 25}px;
    background-size: ${props => props.theme.scale * 25}px;
    padding: ${props => props.theme.scale * 15}px ${props => props.theme.scale * 50}px ${props => props.theme.scale * 0}px ${props => props.theme.scale * 10}px;
    box-sizing: border-box;
`;

const PoiDescription = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: ${props => props.theme.scale * 194}px;
    box-sizing: border-box;
    padding-left: ${props => props.theme.scale * 20}px;
    padding-top: ${props => props.theme.scale * 10}px;
    padding-bottom: ${props => props.theme.scale * 10}px;
    ${(props) =>
        props.theme.textDefault
            && `
            color: ${props.theme.textDefault};
    `}

`;

const PoiTitle = styled.div`
    font-size: ${props => props.theme.scale * 18}px;
    font-family: 'MuseoSans-900';
    ${(props) =>
        props.theme.textDefault
            && `
            color: ${props.theme.textDefault};
    `}
`;

const PoiAdress = styled.div`
    font-size: ${props => props.theme.scale * 16}px;
`;

const Detail = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    padding: ${props => props.theme.scale * 30}px;
    box-sizing: border-box;
`;

const DetailTitle = styled.div`
    font-size: ${props => props.theme.scale * 24}px;
    font-family: 'MuseoSans-900';
    padding-right: ${props => props.theme.scale * 30}px;
    ${(props) =>
        props.theme.textDefault
            && `
            color: ${props.theme.textDefault};
    `}
`;

const DetailDescription = styled.div`
    margin: ${props => props.theme.scale * 20}px 0;
    font-family: 'MuseoSans-300';
    overflow-y: auto;
    ${(props) =>
        props.theme.textDefault
            && `
            color: ${props.theme.textDefault};
    `}
`;

const DetailDescriptionLandscape = styled.div`
    margin: ${props => props.theme.scale * 20}px 0;
    font-family: 'MuseoSans-300';
    overflow-y: auto;
    ${(props) =>
        props.theme.textDefault
            && `
            color: ${props.theme.textDefault};
    `}
`;

const DetailDescriptionPoster = styled.div`
    margin: ${props => props.theme.scale * 20}px 0;
    font-family: 'MuseoSans-300';
    overflow-y: auto;
    ${(props) =>
        props.theme.textDefault
            && `
            color: ${props.theme.textDefault};
    `}
`;

const DetailAdress = styled.div`
    font-size: ${props => props.theme.scale * 16}px;
    font-family: 'MuseoSans-300';
`;

const DetailPhone = styled.div`
    font-size: ${props => props.theme.scale * 16}px;
    font-family: 'MuseoSans-300';
`;

const DetailWebsite = styled.div`
    font-size: ${props => props.theme.scale * 16}px;
    inline-size: ${props => props.theme.scale * 260}px;
    overflow-wrap: break-word;
`;

const DetailText = styled.div`
    font-size: ${props => props.theme.scale * 16}px;
    max-height: ${props => props.theme.scale * 420}px;
    font-family: 'MuseoSans-300';
`;

const DetailTextLandscape = styled.div`
    font-size: ${props => props.theme.scale * 16}px;
    max-height: ${props => props.theme.scale * 285}px;
    font-family: 'MuseoSans-300';
`;

const DetailTextPoster = styled.div`
    font-size: ${props => props.theme.scale * 16}px;
    max-height: ${props => props.theme.scale * 785}px;
    font-family: 'MuseoSans-300';
`;

const DetailMapWrapper= styled.div``;

const DetailQRCodes = styled.div`
    width: 100%;
    height: ${props => props.theme.scale * 150}px;    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    
    img {
        width: ${props => props.theme.scale * 90}px;
    }

    h4 {
        font-size: ${props => props.theme.scale * 12}px;
        text-transform: uppercase;
        margin: 0;
    }
`;

const WebsiteQRCode = styled.div`
    background-color: white;
    text-align: center;
    flex: 0 1 auto;
    width: ${props => props.theme.scale * 100}px;
    margin: ${props => props.theme.scale * 20}px auto;
    display: block;
    position: absolute;
    bottom: ${props => props.theme.scale * 300}px;
    left: ${props => props.theme.scale * 180}px;
    background-color: white;
    padding-top: 5px;
`;

const QRCode = styled.div`
    text-align: center;
    flex: 0 1 auto;
    width: ${props => props.theme.scale * 100}px;
    margin: ${props => props.theme.scale * 20}px auto;
    display: block;
    position: absolute;
    bottom: ${props => props.theme.scale * 300}px;
    left: ${props => props.theme.scale * 20}px;
    background-color: #fff;
    padding-top: 5px;
`;

const DetailImageWrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${props => props.theme.scale * 300}px;
    overflow: hidden;
`;

const DetailImage = styled.img`
    height: 100%;
    width: 100%;
    object-fit: cover;
`;
const Close = styled.div`
    cursor: Pointer;
    user-select: none;
    width: ${props => props.theme.scale * 28}px;
    height: ${props => props.theme.scale * 28}px;
    position: absolute;
    top: ${props => props.theme.scale * 28}px;
    right: ${props => props.theme.scale * 20}px;
`;

const LeftColWrapper = styled(LeftCol)`
        max-height: calc(100%);
`;

const SwipeIndicatorWrapper = styled(SwipeIndicator)`
    position: absolute;
    top: ${props => props.theme.scale * ((props.theme.contentHeight / 2) - 97)}px;
    left: ${props => props.theme.scale * 130}px;
`;

const Attractions = () => {
    const poi = useSelector(state => state.data.imxattractions);
    const selectedAttraction = useSelector(state => state.data.selectedimxattractions);
    const mobiliteReduite = useSelector(state => state.config.mobiliteReduite);
    const swipeIndicator = useSelector(state => state.config.swipeIndicator);
    const layout = useSelector((state) => state.config.layout);
    const theme = useSelector(state => state.config.theme);
    const dispatch = useDispatch();

    const itemClicked = (poi) => {
        dispatch({ type: SET_SELECTED_IMXATTRACTIONS, imxattractions: poi});
        dispatch({ type: SET_ACTIONBUTTON, actionButton: "mail", action: poi.website});
    }

    const closeClicked = () => {
        dispatch({ type: SET_SELECTED_IMXATTRACTIONS, imxattractions: undefined});
        dispatch({ type: SET_ACTIONBUTTON, actionButton: undefined});
    }

    const hideSwiper = () => {
        if (swipeIndicator === true) dispatch({ type: SET_SWIPEINDICATOR, state: false});
    }

    let infoIcon;
    if (!theme.iconSet || theme.useDefaultListInfoIcons) {
        infoIcon = images.icons.info;
    } else {
        infoIcon = `images/themes/${theme.iconSet}/ic_info_black.svg`;
    }

    const featuredItem = poi.find(item => item.name === "Télésiège Vianden" || item.name === "Sessellift Vianden" || item.name === "Chairlift Vianden");
    const otherItems = poi.filter(item => item.name !== "Télésiège Vianden" && item.name !== "Sessellift Vianden" && item.name !== "Chairlift Vianden" && item.name !== "Tourist Info Vianden");
    const finalData = featuredItem ? [featuredItem, ...otherItems] : otherItems;

    return(
        <Container>
            <LeftColWrapper onMouseDown={hideSwiper} onTouchStart={hideSwiper} onScroll={hideSwiper} $mr={mobiliteReduite}>
                <List>
                    {selectedAttraction ? (
                        <Detail>
                            <Close onClick={() => closeClicked()}><img src={images.icons.close} alt="Close" /></Close>
                            <DetailTitle>{selectedAttraction.name}</DetailTitle>
                            {layout === 3 ? (
                                <DetailDescriptionLandscape>
                                    {selectedAttraction.address && <DetailAdress dangerouslySetInnerHTML={{__html: selectedAttraction.address}}></DetailAdress>}
                                    {selectedAttraction.phone && <DetailPhone dangerouslySetInnerHTML={{__html: selectedAttraction.phone}}></DetailPhone>}
                                    {selectedAttraction.website && <DetailWebsite dangerouslySetInnerHTML={{__html: selectedAttraction.website.replace(/<a(.*)href="(.*?)">/g,"").replace(/<\/a>/g,"")}}></DetailWebsite>}
                                    {selectedAttraction.description && <DetailTextLandscape  dangerouslySetInnerHTML={{__html: selectedAttraction.description.replace(/<a(.*)href="(.*?)">/g,"").replace(/<\/a>/g,"")}}></DetailTextLandscape>}
                                </DetailDescriptionLandscape>
                            ): layout === 4 ?(
                                <DetailDescriptionPoster>
                                    {selectedAttraction.address && <DetailAdress dangerouslySetInnerHTML={{__html: selectedAttraction.address}}></DetailAdress>}
                                    {selectedAttraction.phone && <DetailPhone dangerouslySetInnerHTML={{__html: selectedAttraction.phone}}></DetailPhone>}
                                    {selectedAttraction.description && <DetailTextPoster  dangerouslySetInnerHTML={{__html: selectedAttraction.description.replace(/<a(.*)href="(.*?)">/g,"").replace(/<\/a>/g,"")}}></DetailTextPoster>}
                                </DetailDescriptionPoster>
                            ):(
                                <DetailDescription>
                                    {selectedAttraction.address && <DetailAdress dangerouslySetInnerHTML={{__html: selectedAttraction.address}}></DetailAdress>}
                                    {selectedAttraction.phone && <DetailPhone dangerouslySetInnerHTML={{__html: selectedAttraction.phone}}></DetailPhone>}
                                    {selectedAttraction.description && <DetailText  dangerouslySetInnerHTML={{__html: selectedAttraction.description.replace(/<a(.*)href="(.*?)">/g,"").replace(/<\/a>/g,"")}}></DetailText>}
                                </DetailDescription>
                            )}
                            <DetailMapWrapper>
                                <DetailQRCodes>
                                    {selectedAttraction.qrcode && <QRCode><h4>{selectedAttraction.trans_itinerary}</h4><img src={selectedAttraction.qrcode} alt="QR Code" /></QRCode>}
                                    {selectedAttraction.website_qrcode && <WebsiteQRCode><h4>{selectedAttraction.website.replace("Site Web: ","").replace("Webseite: ","").replace("Website: ","").replace(/http:\/\//g,"").replace(/https:\/\//g,"").replace(/www./g,"").replace(/Site web:/g,"").replace("\/","")}</h4><img src={selectedAttraction.website_qrcode} alt="QR Code" /></WebsiteQRCode>}

                                </DetailQRCodes>
                            </DetailMapWrapper>
                            {selectedAttraction.photourl ? <DetailImageWrapper><DetailImage src={selectedAttraction.photourl} alt={selectedAttraction.name} /></DetailImageWrapper> : <DetailImageWrapper><DetailImage src={images.placeholder} alt={selectedAttraction.name} /></DetailImageWrapper>}
                            {swipeIndicator && <SwipeIndicatorWrapper direction="v" />}
                        </Detail>
                    ) : (
                        <List>
                            {finalData.map((item, index) => (
                                <PoiItem key={index} onClick={() => itemClicked(item)} style={{ backgroundImage: `url("${infoIcon}")` }} data-on="click" data-event-category="Attractions" data-event-action="open" data-event-label={item.name}>
                                        <PoiDescription>
                                            <PoiTitle>{item.name}</PoiTitle>
                                            <PoiAdress dangerouslySetInnerHTML={{__html: item.address}}></PoiAdress>
                                        </PoiDescription>
                                    </PoiItem>
                                )
                                
                            )}
                        </List>
                    )}
                </List>
                {swipeIndicator && <SwipeIndicatorWrapper direction="v" />}
            </LeftColWrapper>
            <RightCol>
                <GeoPortailMap poitype={"imxattractions"}></GeoPortailMap>
            </RightCol>
        </Container>
    );
}

export default Attractions;
